import t from 'format-message'

export const navBarMenuItems = (
  activeAssignmentId: string | undefined,
  features: string[],
  isSurvey: boolean,
) => {
  const options = [
    {path: `/build/${activeAssignmentId}`, text: t('Build')},
    {path: `/build/${activeAssignmentId}/settings`, text: t('Settings')},
  ]

  const addTab = ({featureFlag, path, text}: {featureFlag: string; path: string; text: string}) => {
    if (features.includes(featureFlag)) {
      options.push({path, text})
    }
  }

  const moderation = {
    featureFlag: 'moderation',
    path: `/moderation/${activeAssignmentId}`,
    text: t('Moderate'),
  }

  const statistics = isSurvey
    ? {
        featureFlag: 'statistics',
        path: `/reporting/${activeAssignmentId}/survey_statistics`,
        text: t('Reports'),
      }
    : {
        featureFlag: 'statistics',
        path: `/reporting/${activeAssignmentId}`,
        text: t('Reports'),
      }

  if (features.includes('navigation_updates')) {
    addTab(moderation)
    addTab(statistics)
  } else {
    addTab(statistics)
    addTab(moderation)
  }

  addTab({
    featureFlag: 'new_quizzes_exports',
    path: `/exports/${activeAssignmentId}`,
    text: t('Exports'),
  })

  return options
}
